import React from 'react';
import env from 'env';
import { useGet } from 'components';
import { Loading, ErrorPopup } from 'components';

export function Analytics() {
  const get = useGet();

  React.useEffect(() => {
    get.send(env.apiBase + '/api/analyticsAdmin/getSubscriptionSummary');
    // eslint-disable-next-line
  }, []);

  if (get.loading()) {
    return <Loading />;
  } else if (get.hasErrors()) {
    return <ErrorPopup title="Loading Error" errors={get.errors} />;
  }

  const data = get.response;
  const summary = data.summary || {};
  const products = data.products || [];
  const total = (summary.seasonPass || 0) + (summary.adelaideFootyTv || 0) + (summary.singleGames || 0);

  return (
    <>
      <h1>Analytics</h1>
      <h5 style={{ marginBottom: '1.5rem', color: '#6c757d' }}>Subscription Summary (from 17 Apr 2026)</h5>

      <div className="row">
        <div className="col-md-4">
          <StatCard
            label="Season Pass"
            count={summary.seasonPass}
            colour="#0d2e77"
          />
        </div>
        <div className="col-md-4">
          <StatCard
            label="Adelaide Footy TV"
            count={summary.adelaideFootyTv}
            colour="#243b55"
          />
        </div>
        <div className="col-md-4">
          <StatCard
            label="Single Games"
            count={summary.singleGames}
            colour="#4967ab"
          />
        </div>
      </div>

      <div style={{ marginTop: '2rem' }}>
        <table className="table table-bordered">
          <thead className="thead-dark">
            <tr>
              <th>Subscription Type</th>
              <th className="text-right">Total</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Season Pass</td>
              <td className="text-right"><strong>{summary.seasonPass}</strong></td>
            </tr>
            <tr>
              <td>Adelaide Footy TV</td>
              <td className="text-right"><strong>{summary.adelaideFootyTv}</strong></td>
            </tr>
            <tr>
              <td>Single Games</td>
              <td className="text-right"><strong>{summary.singleGames}</strong></td>
            </tr>
            <tr style={{ backgroundColor: '#f8f9fa' }}>
              <td><strong>Total</strong></td>
              <td className="text-right"><strong>{total}</strong></td>
            </tr>
          </tbody>
        </table>
      </div>

      {products.length > 0 && (
        <div style={{ marginTop: '2rem' }}>
          <h5 style={{ marginBottom: '1rem', color: '#6c757d' }}>Breakdown by Product</h5>
          <table className="table table-bordered table-sm">
            <thead className="thead-light">
              <tr>
                <th>Category</th>
                <th>Item Name</th>
                <th className="text-right">Count</th>
              </tr>
            </thead>
            <tbody>
              {products.map((p, i) => (
                <tr key={i}>
                  <td>{p.category}</td>
                  <td>{p.itemName}</td>
                  <td className="text-right"><strong>{p.itemCount}</strong></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </>
  );
}

function StatCard({ label, count, colour }) {
  return (
    <div style={{
      backgroundColor: colour,
      color: '#fff',
      borderRadius: '0.5rem',
      padding: '2rem 1.5rem',
      marginBottom: '1rem',
      textAlign: 'center',
      boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
    }}>
      <div style={{ fontSize: '3rem', fontWeight: '700', lineHeight: 1 }}>{count}</div>
      <div style={{ marginTop: '0.75rem', fontSize: '1rem', opacity: 0.9 }}>{label}</div>
    </div>
  );
}
